import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Car } from "@phosphor-icons/react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("es-DO", { day: "numeric", month: "short", year: "numeric" }) : "");

export const CustomerVehicles = ({ customerId, refreshKey }) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get(`/customers/${customerId}/vehicles`)
      .then(({ data }) => alive && setItems(data.items || []))
      .catch(() => alive && setItems([]));
    return () => { alive = false; };
  }, [customerId, refreshKey]);

  if (!items?.length) return null;
  return (
    <div className="mb-6" data-testid="customer-vehicles">
      <div className="overline mb-2">Vehículos</div>
      <div className="space-y-2">
        {items.map((v, i) => (
          <div key={v.chassis || i} className="border border-border rounded-md p-2.5 text-xs" data-testid={`customer-vehicle-${i}`}>
            <div className="flex items-center gap-1.5 font-semibold">
              <Car size={13} className="text-primary shrink-0" />
              {[v.brand, v.model, v.year].filter(Boolean).join(" ") || "Vehículo"}
            </div>
            <div className="font-mono text-[11px] text-muted-foreground mt-0.5 break-all" data-testid={`customer-vehicle-chassis-${i}`}>
              {v.chassis ? `Chasis ${v.chassis}` : "Chasis pendiente"}
            </div>
            <div className="mt-1.5 space-y-0.5">
              {v.uses.slice(0, 3).map((u, j) => (
                <div key={j} className="text-[11px] text-muted-foreground">
                  · {u.type}{u.detail ? ` — ${u.detail}` : ""}{u.branch ? ` · ${u.branch}` : ""}{u.at ? ` · ${fmt(u.at)}` : ""}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerVehicles;
